export default __webpack_public_path__ + "static/media/our-team-8.49415043.jpg";